import { AnimationFrame as MainAnimationFrame, MovePlayer, SprayingWater, FillWater, PrepareLevel, LevelNumber, ResetMain, IncrementLevel, levelNumber } from './main.js'
import { AnimationFrame as CloudsInAnimationFrame, Reset as CloudsInReset } from './scene-transitionCloudsIn.js'
import { AnimationFrame as CloudsOutAnimationFrame, Reset as CloudsOutReset } from './scene-transitionCloudsOut.js'
import { AnimationFrame as YouLostAnimationFrame } from './scene-youlost.js'
import { AnimationFrame as YouWonAnimationFrame } from './scene-youwon.js'
import { AnimationFrame as MenuAnimationFrame, MenuChange, MenuSelect, Reset as MenuReset } from './scene-menu.js'
import { AnimationFrame as DialogAnimationFrame, Reset as DialogReset } from './scene-dialog.js'
import { AnimationFrame as CreditsAnimationFrame, Reset as CreditsReset } from './scene-credits.js'
import { GetHint } from './levels.js'
import * as SFX from './sfx.js'
import { StopTrack } from './music.js'

var perfectFrameTime = 1000 / 60
var deltaTime = 0
var lastTimestamp = 0

let scenes = [   
    { id: 'menu', animationFrame: MenuAnimationFrame, active: false, inputActive: true,
        handleInput: (inputId, arg) => {
            if (['up', 'down'].includes(inputId)) {
                MenuChange(inputId === 'up' ? -1 : 1)
            }
            if (inputId === 'attack') {
                MenuSelect()
            }
    }, onActivate: MenuReset},
    { id: 'main', animationFrame: MainAnimationFrame, active: false, inputActive: true,
        handleInput: (inputId, arg) => {
            if (['up', 'right', 'down', 'left'].includes(inputId)) {
                MovePlayer(inputId, arg)
            } else if (inputId === 'attack') {
                SprayingWater(arg)
            } else if (inputId === 'suction') {
                FillWater(arg)
            }
    }},
    { id: 'you-lost', animationFrame: YouLostAnimationFrame, active: false, inputActive: true, handleInput: (inputId, arg) => {
        if (inputId === 'attack') {
            SFX.PlayTrack('clouds')
            ActivateScene('transition-clouds-in', (params) => {
                if (params.frame === params.maxFrame) {
                    DeactivateScene('transition-clouds-in')
                    DeactivateScene('you-lost')
                    MenuReset()
                    ActivateScene('menu')
                    ActivateScene('transition-clouds-out', (params) => {
                        if (params.frame === 0) {
                            DeactivateScene('transition-clouds-out')
                        }
                    })
                }
            })
        }
    } },
    { id: 'you-won', animationFrame: YouWonAnimationFrame, active: false, inputActive: true, handleInput: (inputId, arg) => {
        if (inputId === 'attack') {
            SFX.PlayTrack('clouds')
            ActivateScene('transition-clouds-in', (params) => {
                if (params.frame === params.maxFrame) {
                    DeactivateScene('transition-clouds-in')
                    DeactivateScene('you-won')
                    
                    StopTrack('Menu')
                    IncrementLevel()
                    if (levelNumber < 5) {
                        let levelid = 'level' + levelNumber
                        let levelName = 'Level ' + levelNumber
                        PrepareLevel(levelid)
                        ResetMain()
                        ActivateScene('main')
    
                        DialogReset([levelName, GetHint(levelid)])
                        ActivateScene('dialog')
                    } else {
                        ActivateScene('credits')
                    }
    
                    ActivateScene('transition-clouds-out', (params) => {
                        if (params.frame === 0) {
                            DeactivateScene('transition-clouds-out')
                        }
                    })
                }
            })
        }
    } },
    { id: 'credits', animationFrame: CreditsAnimationFrame, active: false, inputActive: false, onActivate: CreditsReset },
    { id: 'dialog', animationFrame: DialogAnimationFrame, active: false, inputActive: false, onActivate: () => {} },
    { id: 'transition-clouds-in', animationFrame: CloudsInAnimationFrame, active: false, inputActive: false, onActivate: CloudsInReset },
    { id: 'transition-clouds-out', animationFrame: CloudsOutAnimationFrame, active: false, inputActive: false, onActivate: CloudsOutReset },    
]

function GetScene(id) {
    let scene = scenes.filter(f => f.id === id)
    return scene.length > 0 ? scene[0] : null
}

function ActiveScenes() {
    return scenes.filter(f => f.active)
}

function ActivateScene(id, onUpdate) {
    let scene = scenes.findIndex(f => f.id === id)
    if (scene > -1) {
        scenes[scene].active = true
        if (scenes[scene].onActivate) {
            scenes[scene].onActivate()
        }
        if (onUpdate) {
            scenes[scene].onUpdate = onUpdate
        }
    }
}

function IsSceneActive(id) {
    let scene = scenes.findIndex(f => f.id === id)
    if (scene > -1) {
        return scenes[scene].active
    }
    return false
}

function DeactivateScene(id) {
    let scene = scenes.findIndex(f => f.id === id)
    if (scene > -1) {
        scenes[scene].active = false
        scenes[scene].onUpdate = undefined
    }
}

function HandleInput(inputId, arg) {
    scenes.filter(f => f.active && f.inputActive).forEach(v => v.handleInput(inputId, arg))
}

function UpdateFrame(timestamp) {
    deltaTime = (timestamp - lastTimestamp) / perfectFrameTime
    lastTimestamp = timestamp
    if (isNaN(deltaTime)) {
        return
    }

    requestAnimationFrame(UpdateFrame)
    //console.log('active scenes', scenes.filter(f => f.active).map(m => m.id))
    scenes.filter(f => f.active).forEach((v, sceneIndex) => {
        v.animationFrame(deltaTime)
    })
}

export { UpdateFrame, HandleInput, ActivateScene, DeactivateScene, IsSceneActive, GetScene, ActiveScenes }